jQuery(document).ready(function() {

  /* Addition of Classes */
  jQuery('ul li:first-child, .widget:first-child').addClass('first');
  jQuery('ul li:last-child, .widget:last-child').addClass('last');
  jQuery('ul.dropdown > li:has(ul)').addClass('dir');

  /* Internal Links Scrolling */
  jQuery('.anchorlinks a, .internal-links a').click(function(event) {
    event.preventDefault();
    jQuery('html,body').animate({scrollTop:jQuery(this.hash).offset().top}, 'slow');
  });

  /* Dropdown */
	jQuery('#nav ul.dropdown > li.current_page_item.menu-item-has-children,#nav ul.dropdown > li.current_page_ancestor.menu-item-has-children').addClass('open');

	jQuery('ul.dropdown > li').hover(function() {
    jQuery(this).addClass('hover');
    jQuery('.dropdown .open').removeClass('open');
    jQuery('.dropdown .dir.hover').addClass('open');
  },function() {
    jQuery(this).removeClass('hover');
  });

  /* SlickNav */
  if(jQuery().slicknav) {
    jQuery('.dropdown').slicknav({
      prependTo: '.slicknav .container', 
      allowParentLinks: true}
    );
  }

  /* Swipebox */
  if(jQuery().swipebox) {
    $('.swipebox').swipebox();
  }

  /* Fancybox */
  if(jQuery().fancybox) {
    $("a.fancybox").fancybox({
      'overlayOpacity':0.7,
      /*'overlayColor':'#FFF', */
      'zoomOpacity':true,
      'overlayShow':false,
      'zoomSpeedIn':500,
      'zoomSpeedOut':500
    });
    $("a.slidebox").fancybox({
      'type' :'iframe',
      'titleShow' : false,
      'autoscale' : true,
      'width' : '600'
    });
  }

  /* Lazy Load */
  if(jQuery().lazyload) {
    $("img.lazy").each(function() {
      $(this).attr("data-original",$(this).attr("src"));
      $(this).removeAttr("src");
    });
    $(".lazy").lazyload({
      effect : "fadeIn"
    });
  }

  /* Jquery Mask */
  if(jQuery().mask) {
    jQuery('.wpcf7-form .wpcf7-tel').mask('(999)999-9999',{placeholder:' '});
  }

  /* Responsive Slideshow */
  if(jQuery().responsiveSlides) {
    jQuery(".home-banner .slideshow").responsiveSlides({
      speed: 800,
      "pager": false
    });
    jQuery(".clients-slideshow").responsiveSlides({
      speed: 800,
      "pager": false
    });
  }

  /* CF7 Tweak */
  jQuery(".wpcf7-form-control-wrap").mouseenter(function() {
    $( this ).find(".wpcf7-not-valid-tip").hide();
  });

  /* Auto-contain Youtube videos */
  $("iframe[src^='http://www.youtube.com'], iframe[src^='https://www.youtube.com'], iframe[src^='//www.youtube.com'], object, embed").each(function() {
	  $(this).wrap( "<div class='video-container'></div>" );
	});

  /* Auto-contain Google Maps */
  $("iframe[src^='http://maps.google.com'], iframe[src^='https://maps.google.com'], iframe[src^='//maps.google.com']").each(function() {
	  $(this).wrap( "<div class='map-container'></div>" );
	});

  /* Clickable Entire Slideshow Background */
  $(".slideshow li[data-href]").click(function() {
    window.location = $(this).data("href");
  });
   
});

//
$('.cycle-slideshow.with-pager').append('<div class="cycle-pager"></div>');

function resizeIframe(obj) {
  obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
}
